<nb-card>
  <nb-card-body class="p-0" style="min-height: 40px; overflow: hidden">
    <app-user-note-alert title="Note:">
      Create a
      <a
        class="selected-text"
        href="https://registry.terraform.io/providers/hashicorp/azurerm/latest/docs/guides/service_principal_client_secret"
        target="_blank"
      >
        service principal
      </a>
      within Azure Active Directory with "owner" rights and whose authentication
      tokens can be used
    </app-user-note-alert>
    <form tabindex="0" [formGroup]="azureAccountForm" class="row mt-2">
      <div class="col-md-12 mt-3">
        <app-reactive-form-field
          label="Name"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="name"
          fieldName="name"
          inputSize="7"
          placeholder="Enter unique name for the account"
          [customFormControl]="name"
          missingMsg="Name is required!"
          invalidPatternMsg="Azure account name should be a lowercase alphanumeric string and can only have hyphens"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="Subscription ID"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="subscriptionId"
          fieldName="subscriptionId"
          inputSize="7"
          placeholder="Enter Subscription ID"
          [customFormControl]="subscriptionId"
          missingMsg="Subscription ID is required"
          invalidPatternMsg="Subscription ID is invalid!"
          [tooltipText]="'Azure subscription id to be used'"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="Tenant"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="tenantId"
          fieldName="tenantId"
          inputSize="7"
          placeholder="Enter Tenant"
          [customFormControl]="tenantId"
          missingMsg="Tenant is required"
          invalidPatternMsg="Tenant is invalid!"
          [tooltipText]="'Azure tenant to be used'"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="App ID"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="clientId"
          fieldName="clientId"
          inputSize="7"
          placeholder="Enter App ID"
          [customFormControl]="clientId"
          missingMsg="App ID is required"
          invalidPatternMsg="App ID is invalid!"
          [tooltipText]="'Azure app id to be used'"
        ></app-reactive-form-field>
      </div>
      <div class="col-xl-12 col-md-12 col-xs-12 mt-3">
        <app-reactive-form-field
          label="Client Secret"
          [required]="true"
          [showInfoAsTooltip]="false"
          labelSize="5"
          fieldId="clientSecret"
          fieldName="clientSecret"
          inputSize="7"
          placeholder="Enter Client Secret"
          [customFormControl]="clientSecret"
          missingMsg="Client Secret is required"
          invalidPatternMsg="Client Secret is invalid!"
          tooltipText="
              Azure client secret to be used. Navigate to your application's key vault. Under settings, in secrets, look for ‘AzureADB2CExternalAuthClientSecret’'
            "
        ></app-reactive-form-field>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer class="p-0 pt-3">
    <app-rbac-button
      [label]="mode === 'create' ? 'Create' : 'Update'"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="saveAccountInProgress"
      [disabled]="azureAccountForm.invalid || saveAccountInProgress"
      (onClick)="createEditAzureAccount()"
    ></app-rbac-button>
    <app-rbac-button
      [label]="'Verify Account'"
      class="mr-3"
      status="primary"
      [action]=""
      [loading]="verifyInProgress"
      [disabled]="azureAccountForm.invalid || verifyInProgress"
      (onClick)="verifyAccount()"
      appearance="outline"
    ></app-rbac-button>
    <button
      nbButton
      size="small"
      class="mr-3"
      (click)="onClickHandleCancel(passedRef)"
    >
      Cancel
    </button>
  </nb-card-footer>
</nb-card>
